var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Fragment from 'ember-data-model-fragments/fragment';
import { assert } from '@ember/debug';
import { isPresent } from '@ember/utils';
import { alias } from '@ember/object/computed';
import environment from '@square/environment-utils/environment';
import { v4 as uuid } from 'uuid';
let EmberDataBaseFragment = (_dec = alias('hasDirtyAttributes'), _class = class EmberDataBaseFragment extends Fragment {
  constructor(...args) {
    super(...args);
    // In our existing code built on ember model, we rely on the isDirty property on the model
    // Ember Data does not have isDirty but instead has a property called hasDirtyAttributes
    // For new code, we should use hasDirtyAttributes directly
    _initializerDefineProperty(this, "isDirty", _descriptor, this);
  }
  toJSON() {
    const serializer = this.store.serializerFor('-default');
    const snapshot = this._internalModel.createSnapshot();
    const options = {};
    return serializer.serialize(snapshot, options);
  }
  static createTestFragment(store, properties) {
    assert('`fragment.createTestRecord()` should only be used in a test environment. Use `this.store.createFragment(...)` in production code.', environment().isTesting);
    assert('Please add `.reopenClass({ _modelNameForMigration: "model-name-goes-here"})` to the fragment class.', isPresent(this._modelNameForMigration));
    if (environment().isTesting) {
      return store.createFragment(this._modelNameForMigration, properties);
    }
    return null;
  }
  static deserializeTestFragment(store, properties = {}) {
    assert('`fragment.deserializeTestFragment()` should only be used in a test environment. Use `this.store.createFragment(...)` in production code.', environment().isTesting);
    assert('Please add `.reopenClass({ _modelNameForMigration: "model-name-goes-here"})` to the model class.', isPresent(this._modelNameForMigration));
    if (!properties.id) {
      // eslint-disable-next-line no-param-reassign
      properties.id = uuid().toString();
    }
    const fragment = store.push(store.normalize(this._modelNameForMigration, properties));

    // ember-data-model-fragment expects this private property to be set,
    // which would typically be set via store.createFragment method.
    fragment._isFragment = true;
    return fragment;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { EmberDataBaseFragment as default };